import { render, staticRenderFns } from "./shelves.vue?vue&type=template&id=292e6d38&"
import script from "./shelves.vue?vue&type=script&lang=ts&"
export * from "./shelves.vue?vue&type=script&lang=ts&"
import style0 from "./shelves.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports